'use client'

import { useLayoutEffect, useRef } from 'react'

const FooterContacts = () => {
  const ref = useRef<HTMLSpanElement>(null)

  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = `
      secretariat@1ocean.org
      <br />
      Tel.: +39 02 796 145
      `
    }
  }, [])

  return (
    <span ref={ref} />
  )
}

export default FooterContacts
